export const DISCORD_LINK = 'https://discord.gg/KBzcUZejTR';
